export default {"src":"/_next/static/media/homecafelogo.416ea22c.svg","height":446,"width":288};